import { Link } from "react-router-dom";

export const SWLink = ({ className, to, content }) => {
  return (
    <Link to={to} className={className} onClick={() => {}}>
      {content}
    </Link>
  );
};
